import React from 'react';
import { Container, Row, Col, Button} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IconArrowUpRight } from '@tabler/icons-react';

const LCissuance = () => {
  const isLogin = useSelector((state) => state.isLogin);
  return (
    <>
      <section className='services'>
        <Container>
          <Row className='justify-content-between align-items-end mb-5'>
            <Col xl={4} lg={6}>
              <div className="head-title mb-0 text-start">
                <div className="sup">Our Services</div>
                <h2>Letter of Credit (LC) <span className='text-gradient'>Issuance</span></h2>
              </div>
            </Col>
            <Col xl={6} lg={6}>
              <p>Navigating international trade requires the right financial guarantees. At MyFX.ca, we specialize in Letter of Credit (LC) issuance to help importers and businesses secure international deals.</p>
            </Col>
          </Row>
          <Row className='justify-content-between'>
            <Col lg={4} sm={6} className='mb-4'>
              <div className="box">
                <img src="../Images/Importers.png" alt="" />
                <h3>LC Solutions for Importers Facing Shortages</h3>
                <p>We assist importers in obtaining LCs through our banking partners, especially in regions facing LC shortages.</p>
              </div>
            </Col>
            <Col lg={4} sm={6} className='mb-4'>
              <div className="box">
                <img src="../Images/Documentation.png" alt="" />
                <h3>Consulting & Documentation Support</h3>
                <p>We provide expert guidance in preparing the necessary documentation and navigating the regulatory landscape for securing LCs.</p>
              </div>
            </Col>
            <Col lg={4} sm={12} className='mb-4'>
              <div className="box">
                <img src="../Images/Solutions.png" alt="" />
                <h3>Tailored LC Solutions</h3>
                <p>Whether you require a Confirmed LC or a Standby LC, we offer customized options that provide security to sellers abroad.</p>
              </div>
            </Col>
          </Row>
          <Row className='justify-content-center mt-lg-5 mt-4'>
            <Col lg={8}>
              <div className="text-center">
                <p>Our online portal allows businesses to submit LC requests and track their applications in real-time, making the process smoother and more transparent. Start your LC application today and leverage our extensive global banking network for success.</p>
                <Button className='button yellow py-3 mt-3' as={Link} to={isLogin ? '/userrequestquote' : '/login'}>Request an LC Quote <IconArrowUpRight size={20} stroke={2} /></Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default LCissuance